import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const NetProfitProcessPayloadSchema = z.object({
    netProfit: z.number().optional(),
});

export class NetProfitProcessPayload extends FromSchema(NetProfitProcessPayloadSchema) {
    netProfit?: number;
}
